import { render, staticRenderFns } from "./ContactoClientes.vue?vue&type=template&id=497c6ca6&lang=pug"
import script from "./ContactoClientes.vue?vue&type=script&lang=js"
export * from "./ContactoClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports